import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { DossierChartId } from "../../types/Chart";

export const getDossierChartData = <TDatum,>(
  dossierId: string,
  chartId: DossierChartId,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierChartData", dossierId, chartId],
    queryFn: (): Promise<TDatum[]> => {
      return fetchWithAuth<TDatum[]>("getDossierChartData", dossierId, {
        queryParams: {
          chartId,
        },
      });
    },
    enabled: isQueryEnabled(options),
    staleTime: SHORT_STALE_TIME,
  });
};
